//./components/Autocomplete.tsx

import classNames  from "classnames";
import React, { memo, useRef, useState ,useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {getCompanyUrl} from 'components/config/Common'

type Props = {
  items: string[];
  value: string;
  onChange(val: string): void;
};

const classes = {
  normal:
    'bg-light ltr:pl-6 rtl:pr-6 ltr:pr-14 rtl:pl-14 ltr:rounded-tr-none rtl:rounded-tl-none ltr:rounded-br-none rtl:rounded-bl-none  border ltr:border-r-0 rtl:border-l-0 border-transparent focus:border-accent',
  minimal:
    'search-minimal bg-light rtl:pr-10 ltr:pr-4 rtl:pl-4 ltr:md:pl-14 rtl:md:pr-14 border border-accent ring-accent focus:border-accent focus:bg-gray-100',
  flat: 'bg-white ltr:pl-10 rtl:pr-10 ltr:pr-4 rtl:pl-4 ltr:md:pl-14 rtl:md:pr-14 border-0',
  'with-shadow':
    'search-with-shadow bg-light ltr:pl-10 rtl:pr-10 ltr:pr-12 rtl:pl-12 ltr:md:pl-14 rtl:md:pr-14 focus:bg-light border-0',
};
//we are using dropdown, input and menu component from daisyui
const Autocomplete = ({
  label,
  onSubmit,
  onClearSearch,
  variant,
  value,
  items,
  searchgroupdata,
  onChange,
  ...rest}) => {
  //const { items, value, onChange } = props;
  const ref = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);
  const [opencontent, setOpencontent] = useState(false);
  //console.log("items",items);
  const navigate = useNavigate();

const handleOutsideClick = (e) => {
  if (ref.current && !ref.current.contains(e.target)) {
    setOpencontent(false);
    console.log("outside click event");
  }
};

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  });

  return (
    <div
      // use classnames here to easily toggle dropdown open 
      className={classNames({
        "dropdown w-full z-[60]": true,
        "dropdown-open": open,
      })}
      ref={ref}
    >
    <input
        id={label}
        type="text"
        value={value}
        autoComplete="off"
        className={classNames(
          'search item-center flex h-full w-full appearance-none overflow-hidden truncate rounded-lg text-sm text-heading placeholder-gray-500 transition duration-300 ease-in-out focus:outline-none focus:ring-0 pl-10',
          {
            'placeholder:text-slate-400': variant === 'flat',
          },
          classes[variant]
        )}
        {...rest}
        placeholder="Search Company"
        data-variant={variant}
        onChange={(e) => { setOpencontent(true); onChange(e) }}
      />
      {/* add this part */}
      <div className="z-50 dropdown-content bg-light top-14 max-h-96 overflow-auto flex-col shadow-md  ">
        <ul
          className="menu menu-compact "
          // use ref to calculate the width of parent
          style={{ width: ref.current?.clientWidth }}
        >
          {opencontent &&  items && items.map((item, index) => {
            return (
              <li
                key={index}
                tabIndex={index + 1}
                onClick={() => {
                  //onChange(item);
                  setOpen(false);
                }}
                className="capitalize  w-full px-4 py-2 border-b border-gray-100 border-b-[1px]   "
              >
               <button className="capitalize text-sm text-gray-500 text-left flex item-start hover:text-accent" onClick={()=>{ onClearSearch();  navigate(getCompanyUrl(item)); }} > {item?.name}</button>   
              </li>
            );
          })}
        </ul>
        {/* add this part */}
      </div>
    </div>
  );
};

export default memo(Autocomplete);